<pui-page-header [title]="'Użytkownicy'">
  <pui-breadcrumbs>
    <a pui-breadcrumbs-item href="/">
      <pui-icon icon="home-line" />
    </a>
    <a pui-breadcrumbs-item href="/">Użytkownicy</a>
  </pui-breadcrumbs>
  <button pui-button variant="primary" (click)="onAdd()">Dodaj użytkownika<pui-icon icon="plus" left />
  </button>
</pui-page-header>


<div class="page-container">
  <pui-table2 [dataSource]="filteredUsers()" [trackBy]="trackBy" [sortBy]="sort().key"
    [sortDirection]="sort().direction" (sortChange)="onSortChange($event)">
    <ng-container header>
      <form class="d-flex align-items-center gap-16 justify-content-between w-100" [formGroup]="filtersForm">
        <pui-form-field>
          <pui-label>Wyszukaj</pui-label>
          <pui-icon icon="search-md" left />
          <input puiInput placeholder="Wyszukaj" formControlName="global" />
        </pui-form-field>
        <pui-divider orientation="vertical" />
        <pui-form-field>
          <pui-label>Typ</pui-label>
          <pui-select [multiple]="false" formControlName="group">
            <pui-placeholder>Typ</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            @for(option of groupTypeOptions; track $index){
            <pui-option [value]="option">{{option}}</pui-option>
            }
          </pui-select>
        </pui-form-field>
        <pui-form-field>
          <pui-label>Rola</pui-label>
          <pui-select [multiple]="false" formControlName="role">
            <pui-placeholder>Rola</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            @for(option of rolesOptions(); track $index){
            <pui-option [value]="option">{{option}}</pui-option>
            }
          </pui-select>
        </pui-form-field>
        <pui-form-field>
          <pui-label>Status</pui-label>
          <pui-select [multiple]="false" formControlName="enabled">
            <pui-placeholder>Status</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            <pui-option [value]="'true'">Aktywny</pui-option>
            <pui-option [value]="'false'">Niektywny</pui-option>
          </pui-select>
        </pui-form-field>
      </form>
    </ng-container>
    <ng-template #header>
      <th pui-column-header key="username">Użytkownik</th>
      <th>Imię</th>
      <th>Nazwisko</th>
      <th>Jednostka</th>
      <th>Organizacja</th>
      <th>Typ</th>
      <th>Rola</th>
      <th>Status</th>
      <th>Akcje</th>
    </ng-template>
    <ng-template #row let-row>
      <tr (click)="onShowDetails(row)" [class.selected]="selectedRow === row">
        <td>{{ row.username }}</td>
        <td>{{ row.firstName }}</td>
        <td>{{ row.lastName}}</td>
        <td>{{ row.responsibleUnit }}</td>
        <td>{{ row.organization }}</td>
        <td><pui-badge [variant]="row.group | groupColor">{{row.group}}</pui-badge></td>
        <td>{{ row.role }}</td>
        <td><pui-badge [variant]="row.enabled ? 'success' : 'danger'">{{row.enabled ? 'Aktywny' :
            'Nieaktywny'}}</pui-badge></td>
        <td class="action-column">
          <button pui-button variant="tertiary" (click)="onEdit(row.username, $event)"><pui-icon class="action-icon"
              left icon="edit-03" /></button>
          <button pui-button variant="tertiary" (click)="onBlock(row, $event)"><pui-icon class="action-icon" left
              icon="lock-01" /></button>
          <button pui-button variant="tertiary" (click)="onSendMail(row, $event)"><pui-icon class="action-icon" left
              icon="mail-01" /></button>
          <button pui-button variant="tertiary" (click)="onDelete(row, $event)"><pui-icon left class="remove-icon"
              icon="trash-03" /></button>
        </td>
      </tr>
    </ng-template>
  </pui-table2>
</div>

<rqa-user-details></rqa-user-details>